import React, { useEffect, useState } from "react";
import {
    Drawer,
    Box,
    Typography,
    IconButton,
    Grid,
    Container,
} from "@mui/material";
import axios from "axios";
import CloseIcon from "@mui/icons-material/Close";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import { BASE_URL } from "../config/network/ApiUrl";

const SidebarMenu = ({ open, onClose, data }) => {

    // const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");
    const [sidebarData, setSidebarData] = useState(null);
    const navigate = useNavigate();
    const location = useLocation(); // 👈 to get current URL
    // const { year, month, issue } = useParams();
    const pathParts = location?.pathname?.split("/");// 👈 get year & month from URL

    // const pathParts = window.location.pathname.split("/");

    const year = pathParts[1];
    const month = pathParts[2];
    const issue = pathParts[3];

    console.log("data in sidebar", data)
    console.log("year in sidebar", pathParts, location)
    console.log("Extracted:", { year, month, issue });
    console.log("sidebarData", sidebarData)

   
    useEffect(() => {
        const fetchSidebarData = async () => {
            try {
                setLoading(true);
                const res = await axios.get(
                    `${BASE_URL}api/inside-pages?year=${year}&month=${month}&issue_number=${issue.split("-")[1]}`
                                        // `/api/inside-pages?year=${year}&month=${month}&issue_number=${issue.split("-")[1]}`

                );
                setSidebarData(res?.data?.data?.items || []);
            } catch (err) {
                console.error(err);
                setError("Failed to load sidebar data");
            } finally {
                setLoading(false);
            }
        };

        const fetchSidebarDataWithoutParams = async () => {
            try {
                setLoading(true);
                const res = await axios.get(
                    `${BASE_URL}api/inside-pages`
                );
                setSidebarData(res?.data?.data?.items || []);
            } catch (err) {
                console.error(err);
                setError("Failed to load sidebar data");
            } finally {
                setLoading(false);
            }
        }

        if (year && month && issue) {
            fetchSidebarData();
        } else {
            fetchSidebarDataWithoutParams()
        }
    }, [year, month, issue]);

    const handleNavigate = (story) => {
        onClose()
        console.log("story data", story)
        const slug = story?.title?.toLowerCase().replace(/\s+/g, "-");
        const url = `/${story?.issue_info?.full_issue}/${slug}`;
        // navigate(url, { state: { story } });
        navigate(url, { state: { story: story, data: sidebarData } });
        window.location.reload();
    };



    return (
        <Drawer
            anchor="top"
            open={open}
            onClose={onClose}
            PaperProps={{
                sx: {
                    width: "100%",
                    height: "100%",
                    backgroundColor: "rgba(0, 0, 0, 0.85)",
                    color: "white",
                    overflow: "auto",
                },
            }}
            transitionDuration={200}
        >
            <Container>
            <Box
                sx={{
                    p: { xs: 3, sm: 6 },
                    display: "flex",
                    flexDirection: "column",
                    height: "100%",
                }}
            >
                {/* Close button */}
                <Box sx={{ display: "flex" }}>
                    <IconButton onClick={onClose} sx={{ color: "white" }}>
                        <CloseIcon sx={{ fontSize: 36 }} />
                    </IconButton>
                </Box>

                {/* Two-column layout — column-wise stacking */}
                <Grid
                    container
                    spacing={.02}
                    //justifyContent="center"
                    alignItems="flex-start"
                    sx={{
                        flexGrow: {md:1,xs:0},
                        mt: 4,
                    }}
                >
                    {/* Left Column */}
                    
                        {sidebarData?.map((story) => (
                                <Grid
                                    item
                                    size={{ xs: 12, md: 6 }}
                                    sx={{
                                        display: "flex",
                                        flexDirection: "column",
                                        gap: .001, // space between items
                                        alignItems: "flex-start",
                                        textAlign: "left",
                                    }}
                                >
                                <Box key={story.id} className="muclass">
                                    {/* Hashtag */}
                                    <Box sx={{ position: "relative", display: "inline-block", mb: 1 }}>
                                        <Typography
                                            sx={{
                                                fontFamily: "'DancingScript-Regular', cursive",
                                                fontSize: "36px",
                                                fontWeight: 550,
                                            }}
                                        >
                                            {story?.field_topic}
                                        </Typography>
                                        {story?.field_topic && <Box
                                            sx={{
                                                position: "absolute",
                                                bottom: "6px",
                                                left: 0,
                                                width: "50px",
                                                height: "2px",
                                                backgroundColor: "#d71920",
                                            }}
                                        />
                                        }
                                    </Box>

                                    {/* Title */}
                                    <Typography
                                        onClick={() => handleNavigate(story)}
                                        sx={{
                                            cursor: "pointer",
                                            fontFamily: "'Georama-Regular'",
                                            fontSize: "20px",
                                            fontWeight: 400,
                                            lineHeight: "1.6rem",
                                            maxWidth: "95%",
                                        }}
                                    >
                                        {story?.title}
                                    </Typography>
                                </Box>                                
                    </Grid>
                            ))}

                    {/* Right Column */}
                    {/* <Grid
                        item
                        xs={12}
                        sm={6}
                        sx={{
                            display: "flex",
                            flexDirection: "column",
                            gap: .001,
                            alignItems: "flex-start",
                            textAlign: "left",
                        }}
                    >
                        {sidebarData
                            ?.filter((_, index) => index % 2 !== 0)
                            .map((story) => (
                                <Box key={story.id}>
                                    <Box sx={{ position: "relative", display: "inline-block", mb: 1 }}>
                                        <Typography
                                            sx={{
                                                fontFamily: "'DancingScript-Regular', cursive",
                                                fontSize: "36px",
                                                fontWeight: 550,
                                            }}
                                        >
                                            {story?.field_topic}
                                        </Typography>
                                        {story?.field_topic && <Box
                                            sx={{
                                                position: "absolute",
                                                bottom: "6px",
                                                left: 0,
                                                width: "50px",
                                                height: "2px",
                                                backgroundColor: "#d71920",
                                            }}
                                        />
                                        }
                                    </Box>
                                    <Typography
                                        onClick={() => handleNavigate(story)}
                                        sx={{
                                            cursor: "pointer",
                                            fontFamily: "'Georama-Regular'",
                                            fontSize: "20px",
                                            fontWeight: 400,
                                            lineHeight: "1.6rem",
                                            maxWidth: "95%",
                                        }}
                                    >
                                        {story?.title}
                                    </Typography>
                                </Box>
                            ))}
                    </Grid> */}
                </Grid>
            </Box>
            </Container>
        </Drawer>

        // <Drawer
        //     anchor="top"
        //     open={open}
        //     onClose={onClose}
        //     PaperProps={{
        //         sx: {
        //             width: "100%",
        //             height: "100%",
        //             backgroundColor: "rgba(0, 0, 0, 0.85)",
        //             color: "white",
        //             overflow: "hidden",
        //         },
        //     }}
        //     transitionDuration={200}
        // >
        //     <Box
        //         sx={{
        //             p: { xs: 3, sm: 6 },
        //             display: "flex",
        //             flexDirection: "column",
        //             height: "100%",
        //         }}
        //     >
        //         {/* Close button */}
        //         <Box sx={{ display: "flex" }}>
        //             <IconButton onClick={onClose} sx={{ color: "white" }}>
        //                 <CloseIcon sx={{ fontSize: 36 }} />
        //             </IconButton>
        //         </Box>

        //         {/* Story grid (2 columns) */}
        //         <Grid
        //             container
        //             spacing={2}
        //             // justifyContent="center"
        //             alignItems="flex-start"
        //             sx={{
        //                 flexGrow: 1,
        //                 mt: 4,
        //                 rowGap: 1, // reduces space between rows
        //             }}
        //         >
        //             {sidebarData?.map((story, index) => (
        //                 <Grid
        //                     item
        //                     xs={12}
        //                     sm={6}
        //                     key={story.id}
        //                     sx={{
        //                         display: "flex",
        //                         flexDirection: "column",
        //                         alignItems: { xs: "center", sm: index % 2 === 0 ? "flex-start" : "flex-start" },
        //                         textAlign: { xs: "center", sm: "left" },
        //                     }}
        //                 >
        //                     {/* Hashtag with underline */}
        //                     <Box sx={{ position: "relative", display: "inline-block", mb: 0.5 }}>
        //                         <Typography
        //                             sx={{
        //                                 fontFamily: "'DancingScript-Regular', cursive",
        //                                 fontSize: "36px",
        //                                 fontWeight: 550,
        //                             }}
        //                         >
        //                             {story?.field_topic}
        //                         </Typography>

        //                         {/* Red underline BELOW text */}
        //                         <Box
        //                             sx={{
        //                                 position: "absolute",
        //                                 bottom: "5px",
        //                                 left: 0,
        //                                 width: "50px",
        //                                 height: "2px",
        //                                 backgroundColor: "#d71920",
        //                             }}
        //                         />
        //                     </Box>

        //                     {/* Story title as clickable link */}
        //                     <Typography
        //                         onClick={() => handleNavigate(story)}
        //                         sx={{
        //                             cursor: "pointer",
        //                             fontFamily: "'Georama-Regular'",
        //                             fontSize: "20px",
        //                             fontWeight: 400,
        //                             lineHeight: "1.6rem",
        //                             //  "&:hover": {
        //                             //     color: "#d71920",
        //                             // },
        //                         }}
        //                     >
        //                         {story?.title}
        //                     </Typography>
        //                 </Grid>
        //             ))}
        //         </Grid>
        //     </Box>
        // </Drawer>
    );
};

export default SidebarMenu;





// import React, { useEffect, useState } from "react";
// import {
//     Drawer,
//     Box,
//     Typography,
//     IconButton,
//     Grid,
// } from "@mui/material";
// import axios from "axios";
// import CloseIcon from "@mui/icons-material/Close";
// import { Link } from "react-router-dom";
// import { useParams } from "react-router-dom";

// const SidebarMenu = ({ open, onClose,data }) => {

//     // const [data, setData] = useState([]);
//     const [loading, setLoading] = useState(true);
//     const [error, setError] = useState("");

//      const { year, month,issue } = useParams(); // 👈 get year & month from URL
//      console.log("data in sidebar",year)

//       const stories = [
//         {
//           id: 1,
//           hashtag: "#MahindraRise",
//           title: "Mahindra & Mahindra – Celebrating the heft of 80!",
//           url: "/2025/september/issue-1/mahindra-mahindra-celebrating-the-heft-of-80",
//         },
//         {
//           id: 2,
//           hashtag: "#RiseToCreateValue",
//           title: "‘Mountains test endurance, resilience, and courage’",
//           url: "/2025/september/issue-1/mountains-test-endurance-resilience-and-courage",
//         },
//         {
//           id: 3,
//           hashtag: "#RiseForAMoreEqualWorld",
//           title: "130 volunteers; 1700kg of waste; 1 clean-up drive!",
//           url: "/2025/september/issue-1/130-volunteers-1700kg-of-waste-1-clean-up-drive",
//         },
//         {
//           id: 4,
//           hashtag: "#RiseToBeFutureReady",
//           title: "Revolutionising customer experience",
//           url: "/2025/september/issue-1/rise-to-be-future-ready",
//         },
//       ];




//     return (
//         <Drawer
//             anchor="top"
//             open={open}
//             onClose={onClose}
//             PaperProps={{
//                 sx: {
//                     width: "100%",
//                     height: "100%",
//                     backgroundColor: "rgba(0, 0, 0, 0.85)",
//                     color: "white",
//                     overflow: "hidden",
//                 },
//             }}
//             transitionDuration={200}
//         >
//             <Box
//                 sx={{
//                     p: { xs: 3, sm: 6 },
//                     display: "flex",
//                     flexDirection: "column",
//                     height: "100%",
//                 }}
//             >
//                 {/* Close button */}
//                 <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
//                     <IconButton onClick={onClose} sx={{ color: "white" }}>
//                         <CloseIcon sx={{ fontSize: 36 }} />
//                     </IconButton>
//                 </Box>

//                 {/* Story grid (2 columns) */}
//                 <Grid
//                     container
//                     spacing={3}
//                     justifyContent="center"
//                     alignItems="flex-start"
//                     sx={{
//                         flexGrow: 1,
//                         mt: 4,
//                         rowGap: 4, // reduces space between rows
//                     }}
//                 >
//                     {stories?.map((story, index) => (
//                         <Grid
//                             item
//                             xs={12}
//                             sm={6}
//                             key={story.id}
//                             sx={{
//                                 display: "flex",
//                                 flexDirection: "column",
//                                 alignItems: { xs: "center", sm: index % 2 === 0 ? "flex-start" : "flex-start" },
//                                 textAlign: { xs: "center", sm: "left" },
//                             }}
//                         >
//                             {/* Hashtag with underline */}
//                             <Box sx={{ position: "relative", display: "inline-block", mb: 0.5 }}>
//                                 <Typography
//                                     variant="h6"
//                                     sx={{
//                                         fontFamily: "cursive",
//                                         fontWeight: 500,
//                                         fontSize: { xs: 20, sm: 24 },
//                                         color: "white",
//                                     }}
//                                 >
//                                     {story.hashtag}
//                                 </Typography>

//                                 {/* Red underline BELOW text */}
//                                 <Box
//                                     sx={{
//                                         position: "absolute",
//                                         bottom: "5px",
//                                         left: 0,
//                                         width: "50px",
//                                         height: "2px",
//                                         backgroundColor: "#d71920",
//                                     }}
//                                 />
//                             </Box>

//                             {/* Story title as clickable link */}
//                             <Typography
//                                 component={Link}
//                                 to={story.url}
//                                 onClick={onClose}
//                                 variant="body1"
//                                 sx={{
//                                     mt: 0.5,
//                                     fontSize: { xs: 15, sm: 17 },
//                                     color: "white",
//                                     opacity: 0.9,
//                                     maxWidth: 420,
//                                     lineHeight: 1.4,
//                                     textDecoration: "none",
//                                     transition: "color 0.3s ease",
//                                     "&:hover": {
//                                         color: "#d71920",
//                                     },
//                                 }}
//                             >
//                                 {story.title}
//                             </Typography>
//                         </Grid>
//                     ))}
//                 </Grid>
//             </Box>
//         </Drawer>
//     );
// };

// export default SidebarMenu;







